import React from 'react'
import { createRoot } from 'react-dom/client'
import 'index.css'
import App from 'components/application/App'

const container = document.getElementById('appointment_form')
const appointmentForm = createRoot(container)
const lang = container.getAttribute('lang')
const treatments = container.getAttribute('treatments')
const hideUrlAttribute = container.getAttribute('hideurl')
const hideUrl = hideUrlAttribute && hideUrlAttribute !== 'false'
appointmentForm.render(<App lang={lang} treatments={JSON.parse(treatments)} hideUrl={hideUrl} />)
